module.exports = __webpack_public_path__ + "page4.5719bf17.png";